module.exports = __webpack_public_path__ + "flashfood-site-mockup.svg?bf1c5cb12d4ec421552c3b3c64a6bc5f";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/flashfood-site-mockup.svg
// module id = 314
// module chunks = 0